import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { jaJP } from '@mui/x-data-grid';
import { usePost } from './../../apis/ApiRequests';
import { useAuth } from '../../contexts/AuthContext';
import { dateToString } from '../../utils/Library';
import Header from '../../components/Header';
import Frame from '../../components/uiParts/Frame';
import TitleBar from '../../components/uiParts/TitleBar';
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid';
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import UpdateIcon from '@mui/icons-material/Update';
import { useGridApiRef } from '@mui/x-data-grid';

const UnloadDataList = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth();
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const luserName      = authInfo.userName;
    const authority      = authInfo.authority;
    const today          = authInfo.targetDate;
    
    const search    = useLocation().search;
    const query     = new URLSearchParams(search);
    const targetDate  = query.get("targetDate") || today;
    const checkStatus  = query.get("checkStatus") || 1;
    
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const apiRef          = useGridApiRef();

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate,             setEntryDate             ] = useState(targetDate);
    const [ condition ,            setCondition             ] = useState('');
    const [ searchStatus ,         setSearchStatus          ] = useState(checkStatus);
    const [ searchCount,           setSearchCount           ] = useState(0);
    const [ dataGridHeight,        setDataGridHeight        ] = useState(window.innerHeight - 210);
    const [ dataInputList,         setDataInputList         ] = useState([]);
    const [ checkedDataInputList,  setCheckedDataInputList  ] = useState([]);
    const [ targetId,              setTargetId              ] = useState(0);
    const [ targetCell,            setTargetCell            ] = useState('methodCode');
    const [ prevRow,               setPrevRow               ] = useState({});
    const [ requireMessage,        setRequireMessage        ] = useState('')
    
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue        : false,
        snackBarTrue_print  : false,
        snackBarFalse       : false,
        require             : false,
        confirm             : false,
        confirm_next        : false,
        confirm_delete_row  : false,
        confirm_register    : false,
        confirm_status_done : false,
        confirm_status_none : false
    });
	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
	// API - searchData / BidGroup
	//-----------------------------------------------
	const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost();
	const searchData = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'       : 'mch.models.table.Transaction',
            'methodName'      : 'searchData',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'transactionType' : '1',
            'keyword1'        : numericDate,
            'keyword2'        : condition,
            'keyword3'        : searchStatus
        }
        await searchData_post(postData);
	};
	//-----------------------------------------------
    // API - updateTransaction / Transaction
	//-----------------------------------------------
    const { response : setData_res, loading : setData_Loading, post:setData_post } = usePost();
    const setData = async (targetDate) => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'       : 'mch.models.table.Transaction',
            'methodName'      : 'setDataByUser',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'transactionType' : '1',
            'uniqueKey'       : targetDate.uniqueKey,
            'activeFlag'      : targetDate.activeFlag,
            'reportNo'        : targetDate.reportNo,
            'reportSeq'       : targetDate.reportSeq,
            'entryDate'       : numericDate, 
            'uniqueKey'       : targetDate.uniqueKey,
            'bidName'         : targetDate.bidName,
            'senmeiCode'      : targetDate.senmeiCode,
            'senmei'          : targetDate.senmei,
            'gyoshuCode'      : targetDate.gyoshuCode,
            'gyoshu'          : targetDate.gyoshu,
            'nisugata'        : targetDate.nisugata,
            'kikakuCode'      : targetDate.kikakuCode,
            'kikaku'          : targetDate.kikaku,
            'methodCode'      : targetDate.methodCode,
            'method'          : targetDate.method,
            'kgSuryo'         : targetDate.kgSuryo,
            'kgKubun'         : targetDate.kgKubun,
            'suryo'           : targetDate.suryo,
            'traderCode'      : targetDate.traderCode,
            'trader'          : targetDate.trader,
            'entrySuryo'      : targetDate.entrySuryo,
            'entryUnit'       : targetDate.entryUnit,
            'bidSuryo'        : targetDate.bidSuryo,
            'tanka'           : targetDate.tanka,
            'checkStatus'     : 0,
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost();
    const getData_ship = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_ship_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost()
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost()
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishMethod
	//-----------------------------------------------
    const { response : getData_fishMethod_res, post : getData_fishMethod_post } = usePost()
    const getData_fishMethod = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishMethod_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1);
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 210);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    },[]);
	//-----------------------------------------------
    // useEffect - 検索処理
	//-----------------------------------------------
    useEffect(() => {
        searchData();
    }, [searchCount]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(searchDataByDataInput / bidGroup)
	//-----------------------------------------------
    useEffect(() => {
        setDataInputList([]);
        if (searchData_res) {
            setDataInputList(searchData_res.Data);
        }
    }, [searchData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            setMessageInfo('confirm_delete_row', false);
            setMessageInfo('confirm_register', false);
            setMessageInfo('snackBarTrue', true);
            setSearchCount(searchCount+1);
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - チェック済みのデータを操作する
	//-----------------------------------------------
    useEffect(() => {
        if (dataInputList) {
            // bidStatusが1の行のIDを集める
            const selectedRows = dataInputList.filter(row => row.deliveryStatus === 1).map(row => row.id);
            setCheckedDataInputList(selectedRows);
        }
    }, [dataInputList]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_ship_res.displayName) {
                            row.senmeiCode  = getData_ship_res.code;
                            row.senmei      = getData_ship_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.senmeiCode  = prevRow.senmeiCode;
                            row.senmei      = prevRow.senmei;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_fishSpec_res.displayName) {
                            row.gyoshuCode  = getData_fishSpec_res.code;
                            row.gyoshu      = getData_fishSpec_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.gyoshuCode  = prevRow.gyoshuCode;
                            row.gyoshu      = prevRow.gyoshu;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_fishSpec_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_standard_res.displayName) {
                            row.kikakuCode  = getData_standard_res.code;
                            row.kikaku      = getData_standard_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.kikakuCode  = prevRow.kikakuCode;
                            row.kikaku      = prevRow.kikaku;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_standard_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishMethod)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishMethod_res) {
            setDataInputList((prevData) => {
                return prevData.map((row) => {
                    if (row.id === targetId) {
                        if (getData_fishMethod_res.displayName) {
                            row.methodCode  = getData_fishMethod_res.code;
                            row.method      = getData_fishMethod_res.displayName;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            row.methodCode  = prevRow.methodCode;
                            row.method      = prevRow.method;
                        }
                        return row;
                    }
                    return row;
                });
            });
        }
    }, [getData_fishMethod_res]);

	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
        setEntryDate(value);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索ボタン
	//-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - 検索クリアボタン
	//-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today);
        setCondition('');
        setSearchStatus(1);
        setSearchCount(searchCount+1);
    };
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const handleClick_addRow = () => {
        let newId = dataInputList.length > 0 ? Math.max(...dataInputList.map(r => r.id)) + 1 : 1;
        const newRows = generateNewRows(newId, 1);
        setDataInputList([...dataInputList, ...newRows]);
    }
	//-----------------------------------------------
    // eventHandler - ブランク行を追加
	//-----------------------------------------------
    const generateNewRows = (startId, count) => {
        const rows = [];
        for (let i = 0; i < count; i++) {
            rows.push({
                id: startId + i,
                reportNo       : '', 
                reportSeq      : 1, 
                entryDate      : entryDate, 
                uniqueKey      : '',
                bidName        : '',
                senmeiCode     : '',
                senmei         : '',
                gyoshuCode     : '', 
                gyoshu         : '', 
                nisugata       : '',
                kikakuCode     : '',
                kikaku         : '',
                methodCode : '',
                method     : '',
                kgSuryo        : '', 
                kgKubun        : '', 
                suryo          : '', 
                traderCode     : '', 
                trader         : '', 
                entrySuryo     : '', 
                entryUnit      : '', 
                bidSuryo       : '', 
                tanka          : '', 
                checkStatus    : 0,
            })
        }
        return rows;
    }
	//===============================================
	// dataGrid
	//===============================================
	//-----------------------------------------------
    // dataGrid - 入札管理の見出し
	//-----------------------------------------------
    const columnsxBidGroup = [
        { field: 'reportNo', headerName: '伝票No', width: 110, columnSeparatorWidth: 1, sortable:false, },
        { field: 'methodCode', headerName: 'コード', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'method', headerName: '漁法', width: 120, columnSeparatorWidth: 1, sortable:false, headerAlign:'left', },
        { field: 'senmeiCode', headerName: 'コード', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'senmei', headerName: '荷主', width: 120, columnSeparatorWidth: 1, sortable:false, headerAlign:'left', },
        { field: 'gyoshuCode', headerName: 'コード', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'gyoshu', headerName: '魚種', width: 120, columnSeparatorWidth: 1, sortable:false, headerAlign:'left', },
        { field: 'nisugata', headerName: 'コード', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        {
            field: 'nisugataCode',
            headerName: '荷姿',
            headerAlign:'left',
            width: 80, sortable:false,
            renderCell: (params) => (
              <div>
                {nisugataMapping[params.value] || params.value}
              </div>
            ),
        },
        { field: 'kikakuCode', headerName: 'コード', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        { field: 'kikaku', headerName: '規格', width: 120, columnSeparatorWidth: 1, sortable:false, },
        { field: 'kgSuryo', headerName: 'Kg数量', width: 80, columnSeparatorWidth: 1, type:'number', sortable:false, editable:true},
        { field: 'suryo', headerName: '数量', width: 80, columnSeparatorWidth: 1, type:'number', sortable:false, editable:true},
        { field: 'kgKubun', headerName: 'コード', width: 80, columnSeparatorWidth: 1, sortable:false, headerAlign:'right', align:'right', editable:true, },
        {
            field: 'kgKubunCode',
            headerName: '単位',
            width: 80, sortable:false,
            renderCell: (params) => (
              <div>
                {unitMapping[params.value] || params.value}
              </div>
            ),
        },
    ];
    const unitMapping = {
        1: 'Kg',
        0: '箱',
    };
    const nisugataMapping = {
        0: '鮮魚',
        1: '活魚',
    };
    //-----------------------------------------------
    // dataGrid - テンキーのクリック
    //-----------------------------------------------
    const handleCellKeyDown = (event, params) => {
        setTargetId(event.id);
        setTargetCell(event.field);
    };
    //-----------------------------------------------
    // dataGrid - 行の更新処理
    //-----------------------------------------------
    const handleProcessRowUpdate = (newRow, oldRow) => {
        let targetId = newRow.id;
        setTargetId(targetId);
        setDataInputList((prevData) => {
            return prevData.map((row) => {
                if (row.id === targetId) {
                    if (targetCell == 'senmeiCode') getData_ship(newRow.senmeiCode);
                    if (targetCell == 'gyoshuCode') getData_fishSpec(newRow.gyoshuCode);
                    if (targetCell == 'kikakuCode') getData_standard(newRow.kikakuCode);
                    if (targetCell == 'methodCode') getData_fishMethod(newRow.methodCode);
                    if (targetCell == 'nisugata') {
                        if (newRow.nisugata == 1) {
                            newRow.nisugataCode = 1;
                        } else if (newRow.nisugata == 0) {
                            newRow.nisugataCode = 0;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            newRow.nisugataCode = prevRow.nisugataCode;
                            newRow.nisugata     = prevRow.nisugata;
                        }
                    }
                    if (targetCell == 'kgKubun') {
                        if (newRow.kgKubun == 1) {
                            newRow.kgKubunCode = 1;
                        } else if (newRow.kgKubun == 0) {
                            newRow.kgKubunCode = 0;
                        } else {
                            setRequireMessage('マスタに登録がありません');
                            setMessageInfo('require', true);
                            newRow.kgKubunCode = prevRow.kgKubunCode;
                            newRow.kgKubun     = prevRow.kgKubun;
                        }
                    }
                    return newRow;
                }
                return row;
            });
        });
        return newRow;
    };
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataInputList = (event) => {
        if (event.field === '__check__') {
            if (checkedDataInputList.includes(event.id)) {
                setCheckedDataInputList(checkedDataInputList.filter((checkedDataInputList, index) => (checkedDataInputList !== event.id)));
            } else {
                setCheckedDataInputList((checkedDataInputList)=>[...checkedDataInputList, event.id]);
            }
        }
        // 現在のフォーカスをセット
        setTargetId(event.id);
        setTargetCell(event.field);

        dataInputList.map((row) => {
            if (row.id === event.id) {
                setPrevRow(row);
            }
        });
    };
	//-----------------------------------------------
    // dataGrid - フォーカス制御
	//-----------------------------------------------
    useEffect(() => {
        // データが読み込まれていることを確認
        if (dataInputList.length > 0) {
            
            // フォーカスを右側のセルに移動する
            let i = targetId;
            let j = 'methodCode';
            if (targetId) {
                if (targetCell == 'methodCode') j = 'senmeiCode';
                if (targetCell == 'senmeiCode') j = 'gyoshuCode';
                if (targetCell == 'gyoshuCode') j = 'nisugata';
                if (targetCell == 'nisugata') j = 'kikakuCode';
                if (targetCell == 'kikakuCode') j = 'kgSuryo';
                if (targetCell == 'kgSuryo') j = 'suryo';
                if (targetCell == 'suryo') j = 'kgKubun';
                if (targetCell == 'kgKubun') {
                    ++i;
                    j = 'methodCode';
                    setTargetId(j);
                }
                apiRef.current.setCellFocus(i, j);
            }
        }
    }, [dataInputList]);
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
    // Function - 登録処理
	//-----------------------------------------------
    const register = (status) => {

        dataInputList.map((targetData) => {
            targetData.activeFlag  = 1;
            setData(targetData);
        });
        return false;
    };
	//-----------------------------------------------
    // Function - 選択行の削除
	//-----------------------------------------------
    const delete_row = async () => {
        checkedDataInputList.map((item) => {
            dataInputList.map((targetData) => {
                if (item == targetData.id) {
                    targetData.activeFlag  = 0;
                    setData(targetData);
                }
            })
        });
        return false;
    };
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    //===============================================
    // Css
    //===============================================
    
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" setEntryDate={handleChange_entryDate} />
            <div className='dataInput bodyContens'>
                <TitleBar title="荷受けデータ補正" />
                <div className='mainContents'>
                    <Frame classname="frame" title="荷受けデータ検索">
                        <div style={{display:'flex'}}>
                            <div> 
                                <BidSearchForm
                                    targetDateId       = "dataInput_targetDate"
                                    targetDateValue    = { entryDate }
                                    targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                    keywordId          = "dataInput_condition"
                                    keywordValue       = { condition }
                                    keywordOnChange    = { (e) => setCondition(e.target.value) }
                                    handleSearch       = { () => handleClick_search() }
                                    handleSearchClear  = { () => handleClick_search_clear() }
                                />
                            </div>
                            {/*
                            <div style={{marginLeft:'40px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<AddCircleIcon />}
                                    onClick   = {() => handleClick_addRow() }
                                >
                                行追加
                                </Button>
                            </div>
                            <div style={{marginLeft:'10px'}}>
                                <Button
                                    color     = "secondary"
                                    style     = {{color:'#fff', backgroundColor: 'grey'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<DeleteIcon />}
                                    onClick   = {() => setMessageInfo('confirm_delete_row', true) }
                                >
                                行削除
                                </Button>
                            </div>
                            */}
                            <div style={{marginLeft:'40px'}}>
                                <Button
                                    color     = "primary"
                                    style     = {{color:'#fff'}}
                                    size      = "midium"
                                    variant   = "contained"
                                    startIcon = {<UpdateIcon />}
                                    onClick   = { () => setMessageInfo('confirm_register', true) }
                                >
                                保存
                                </Button>
                            </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                            <CustomDataGrid
                                apiRef = { apiRef }
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { dataInputList }
                                columns                 = { columnsxBidGroup }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                disableRowSelectionOnClick = {false}
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClick_dataInputList(event)}
                                processRowUpdate           = {handleProcessRowUpdate}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedDataInputList(newSelectionModel) }}
                                rowSelectionModel          = {checkedDataInputList}
                                loading = { searchData_Loading }
                                onCellKeyDown              = {handleCellKeyDown}

                            />
                        </div>
                    </Frame>
                </div>
            </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarTrue_print}
                    onClose         = {() => setMessageInfo('snackBarTrue_print', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "印刷指示を送信しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm_delete_row}
                    onClose   = {() => setMessageInfo('confirm_delete_row', false)}
                    onClickNG = {() => setMessageInfo('confirm_delete_row', false)}
                    onClickOK = {() => delete_row(0)}
                    message   = {'選択行を削除します。よろしいですか？'}
                />
                <CustomConfirm
                    open      = {messageState.confirm_register}
                    onClose   = {() => setMessageInfo('confirm_register', false)}
                    onClickNG = {() => setMessageInfo('confirm_register', false)}
                    onClickOK = {() => register()}
                    message   = {'入力データを保存します。よろしいですか？'}
                />
        </>
    )
}
export default UnloadDataList;